import React from 'react';
import ReactDOM from 'react-dom';
import { FocusPanel } from './focus-panel';
import { safeCallback } from '../../../library';
export function CascadingFocusPanels(props) {
    var _a = props.openIds, openIds = _a === void 0 ? [] : _a;
    var normalisedChildren = (Array.isArray(props.children) ? props.children : [props.children]);
    var mappedChildrenProps = normalisedChildren.map(function (i) { return i === null || i === void 0 ? void 0 : i.props; }).filter(function (i) { return !!(i === null || i === void 0 ? void 0 : i.id); });
    var length = Math.max(openIds.length - 1, 0);
    return ReactDOM.createPortal(React.createElement(React.Fragment, null, openIds.map(function (id, index) {
        var isTop = index === length;
        var child = mappedChildrenProps.find(function (c) { return c.id === id; });
        if (!child || !child.id)
            throw new Error("No child found for id ".concat(id));
        return (React.createElement(FocusPanel, { onClose: function () { return safeCallback(props.onClosePanelById, id); }, overlayStyle: isTop ? 'default' : 'none', open: openIds.includes(child.id), key: child.id, shiftBy: 100 * (length - index), zIndex: isTop ? 101 : 50 }, child.children));
    })), window.document.body);
}
export default CascadingFocusPanels;
